module.exports = __webpack_public_path__ + "img/reismehltaschengarnelenbaerlauch.a56ac5c1.jpg";